import styled from 'styled-components';

const FilterBadgesRootElement = styled.div`
  .filter-badges {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    flex-basis: 100%;
    flex-wrap: wrap;
    button {
      display: flex;
      align-items: center;
      min-width: 3rem;
      padding: 5px 12px;
      font-size:0.875rem;
      &.showFilter{
        min-width: 3rem;
        justify-content: flex-start;
      }
      & span {
        margin-left: 0;
        margin-right: 8px;
      }
      &:hover, &:active, &:focus, &:focus:active {
        min-width: 3rem;
        padding: 5px 12px;
        font-size:0.875rem;
      }
    }
    .clear-all{
      text-decoration: underline;
      &:hover{
        box-shadow: none;
      }
    }
    .filter-badge-row{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      @media (max-width: 767px) {
        padding-top:10px;
        width: 100%;
        flex: none;
      }
    }
  };
`;

export default FilterBadgesRootElement;
